import type { ProductProfileProductEntity } from "src/app/features/ProductProfile/types/subTypes/ProductProfileProductEntity";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { ID } from "../../../../core/types/fe/types";

export const orgUnitsProductsProfileApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => {
        return {
            loadOrgUnitProducts: builder.query<ProductProfileProductEntity[], { orgUnitId?: number } | void>({
                providesTags: ["mainCache"],
                query: (params) => {
                    const dataGroup = getAssignedDataGroup();
                    return {
                        url: `${ResourceName.DATA_GROUPS}/${dataGroup.code}/${ResourceName.PRODUCTS}/org-units`,
                        method: "GET",
                        params: params
                            ? {
                                  ...(params.orgUnitId !== undefined && { orgUnitId: params.orgUnitId }),
                              }
                            : undefined,
                    };
                },
                transformResponse: (response: { items: ProductProfileProductEntity[] }) => {
                    return response.items;
                },
            }),
            loadProductsByProfile: builder.query<ProductProfileProductEntity[], { productProfileId?: ID; productIds?: number[] } | void>({
                providesTags: ["mainCache"],
                query: (params) => {
                    const dataGroup = getAssignedDataGroup();
                    return {
                        url: `${ResourceName.DATA_GROUPS}/${dataGroup.code}/${ResourceName.PRODUCT_PROFILES}/${ResourceName.PRODUCTS}`,
                        method: "GET",
                        params: {
                            ...(params?.productProfileId !== undefined && { productProfileId: params.productProfileId }),
                            ...(params?.productIds?.length && { productIds: params.productIds }),
                        },
                    };
                },
                transformResponse: (response: { items: ProductProfileProductEntity[] }) => {
                    return response.items;
                },
            }),
            loadProductsByParentOrgUnit: builder.query<
                ProductProfileProductEntity[],
                { orgUnitId: ID; productIds?: number[]; isParent?: boolean }
            >({
                providesTags: ["mainCache"],
                query: (params) => {
                    const dataGroup = getAssignedDataGroup();
                    return {
                        url: `${ResourceName.DATA_GROUPS}/${dataGroup.code}/${ResourceName.PRODUCT_PROFILES}/org-units/${params.orgUnitId}`,
                        method: "GET",
                        params: {
                            ...(params?.productIds?.length && { productIds: params.productIds }),
                            ...(params?.isParent !== undefined && { isParent: params.isParent }),
                        },
                    };
                },
                transformResponse: (response: { items: ProductProfileProductEntity[] }) => {
                    return response.items;
                },
            }),
        };
    },
});

export const { useLazyLoadOrgUnitProductsQuery, useLazyLoadProductsByProfileQuery, useLazyLoadProductsByParentOrgUnitQuery } =
    orgUnitsProductsProfileApi;
